module.exports = __webpack_public_path__ + "gs.21f7c99f17bb19ebe4b9.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/gs.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/gs.svg
// module chunks = styles